<div style="position: relative">
    {{ label }}
    <vpfa-price-with-icon
      style="position: absolute; right: 0"
      [color]="'orange'"
      [price]="showValue ? null : ' '"
      *ngIf="notAvailable; else elseTemplate"
    ></vpfa-price-with-icon
    ><ng-template #elseTemplate>{{ showValue ? '(' + value + ')' : ''}}</ng-template>
  </div>